"use client";

import BaseStoreBox from "../shared/base-store-box";
import ChatReachOutBox from "./ChatReachOutBox";
import Drawermenu from "./drawer-menu";
import styles from "./index.module.css";
import StoreHeader from "./store-header";
import StoreSideMenu from "./store-side-menu";

const defaultTemplateClassNames = {
  dropdown: {
    storeHeaderLocation: {
      root: styles.headerLocationDropdown,
      button: styles.locationDropdownButton,
      text: styles.locationDropdownText,
      list: styles.locationDropdownList,
      item: styles.locationDropdownItem,
    },
    storeDrawerLocation: {
      root: styles.drawerLocationDropdown,
      button: styles.locationDropdownButton,
      text: styles.locationDropdownText,
      list: `${styles.locationDropdownList} ${styles.drawerLocationDropdownList}`,
      item: styles.locationDropdownItem,
    },
  },
};

function StoreBox(props) {
  return (
    <BaseStoreBox
      {...props}
      styles={styles}
      templateClassNames={defaultTemplateClassNames}
      Drawermenu={Drawermenu}
      StoreSideMenu={StoreSideMenu}
      StoreHeader={StoreHeader}
      ChatReachOutBox={ChatReachOutBox}
    />
  );
}

export default StoreBox;
